import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'colcade/colcade.js'
import router from './router'

createApp(App).use(router).mount('#app')
